import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
    selector: '[appDecimaNumber]'
})
export class DecimaNumberDirective {
    private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', 'Enter'];
    constructor(private el: ElementRef) {
        let decimal_number = this.el.nativeElement.getAttribute('appDecimaNumber')
        if (decimal_number != '') {
            decimal_number = parseInt(decimal_number);
            this.regex = new RegExp('^\\d*\\.?\\d{0,' + decimal_number + '}$');
        }
    }
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        let current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}